import { PreviewIcon } from '@/src/assets/svgs'
import { useConsentForms, useDocTemplate } from '@/src/hooks'
import { ConsentFormDataMock } from '@/src/types/consent_form.type'
import { useModalStore } from '@/src/zustand/Modal'
import { ADMIN_MODAL_TYPE } from '@data'
import { FormButton, Loader, Modal, RadioBtn } from '@ui'
import { getError } from '@util'
import { Text } from 'grommet'
import { Fragment, useMemo, useState } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'

type Props = {
  onClose: () => void
  id?: string
  defaultData?: ConsentFormDataMock
}
type CardProps = {
  handleChecked: (arg: string) => void
  id: string
  items: string[]
}

export const Card = ({ id, items, handleChecked }: CardProps) => (
  <label className={`flex items-center px-4 justify-between flex-row-reverse py-3 cursor-pointer transition-all`}>
    <RadioBtn
      name="code"
      onChange={() => {
        handleChecked(id)
      }}
      type="radio"
    />
    <div className="flex flex-wrap">
      {items?.map((item, index) => (
        <Fragment key={index}>
          <Text size="small" style={{ maxWidth: '300px' }} truncate>
            {item}
          </Text>
          {/* Separator (except last) */}
          {index !== items?.length - 1 && <Text aria-hidden="true" className="mx-2 h-4 w-px bg-gray-300" />}
        </Fragment>
      ))}
    </div>
  </label>
)

export const PreviewTemplate = ({ onClose, defaultData, id }: Props) => {
  const { addConsent } = useConsentForms()
  const { openModal } = useModalStore()
  const { patientId: patient_id, intakeId } = useParams<string>()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [searchParams] = useSearchParams()
  const { documents, isLoading: documentsIsLoading } = useDocTemplate()
  const intake_id = searchParams.get('intake_id') || intakeId || ''
  const [checked, handleChecked] = useState('')

  const options = useMemo(() => {
    if (documents) {
      return documents?.map(({ id, attributes: { title } }) => ({
        id,
        label: title
      }))
    } else return []
  }, [documents])

  const onSubmit = async () => {
    if (!checked) return

    const payload = {
      document_template_id: checked,
      patient_id,
      intake_id
    }
    setIsLoading(true)

    try {
      openModal(ADMIN_MODAL_TYPE.CONSENT_FORM, { id: defaultData?.id, doc_temp_id: checked })
      onClose()
    } catch (error) {
      getError(error)
    }
    setIsLoading(false)
  }
  return (
    <Modal onClose={onClose} title="Add Template">
      {documentsIsLoading ? (
        <div className="max-h-20">
          <Loader />
        </div>
      ) : (
        <div className="flex flex-col md:w-full max-w-[550px] w-full overflow-auto">
          <div className="flex flex-col overflow-auto gap-6 p-6">
            {options?.map(({ id, label }) => {
              return <Card handleChecked={handleChecked} id={id} items={[label]} key={id} />
            })}
          </div>
          <FormButton
            isLoading={isLoading}
            onClick={onSubmit}
            onClose={onClose}
            rightIcon={<PreviewIcon color="white" fill="white" />}
            submit="Preview"
          />
        </div>
      )}
    </Modal>
  )
}
